import { render, staticRenderFns } from "./app-not-installed-indicator.vue?vue&type=template&id=272bc5b7"
import script from "./app-not-installed-indicator.vue?vue&type=script&lang=js"
export * from "./app-not-installed-indicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports